import { useTheme } from "@/theme/ThemeProvider";

export function Logo({ size = 32 }: { size?: number }) {
  const p = useTheme();
  return (
    <div
      style={{
        width: size,
        height: size,
        background: p.accent,
        border: `2px solid ${p.border}`,
        display: "grid",
        placeItems: "center",
        fontSize: size * 0.55,
        fontWeight: 800,
        color: p.accentFg,
        flexShrink: 0,
        transition: "background .25s, border-color .25s",
      }}
    >
      ♞
    </div>
  );
}
